import { useEffect, useState } from 'react';

export interface ChartThemeColors {
  label: string;
  grid: string;
  series: string;
}

function readChartThemeColors(): ChartThemeColors {
  if (typeof document === 'undefined') {
    return { label: '#718096', grid: '#e2e8f0', series: '#2563eb' };
  }
  const root = document.documentElement;
  const style = getComputedStyle(root);
  const pick = (name: string, fallback: string) => {
    const v = style.getPropertyValue(name).trim();
    return v || fallback;
  };
  return {
    label: pick('--text-muted', '#718096'),
    grid: pick('--border-default', '#e2e8f0'),
    series: pick('--brand-primary', '#2563eb')
  };
}

/** Reads platform CSS variables; updates when `[data-theme]` changes. */
export function useChartThemeColors(): ChartThemeColors {
  const [colors, setColors] = useState(readChartThemeColors);

  useEffect(() => {
    const refresh = () => setColors(readChartThemeColors());
    const obs = new MutationObserver(refresh);
    obs.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme', 'data-theme-family']
    });
    return () => obs.disconnect();
  }, []);

  return colors;
}
